import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { timeMapping } from 'assert/OptionList';
import moment from 'moment';
const domains = [
  '@gmail.com',
  '@outlook.com',
  '@icloud.com',
  '@yahoo.com',
];

const usernameRegex = /^[a-zA-Z0-9_]{3,50}$/;
const UrlRegex =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g;
const EmailRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const swipeModalWidth = 768;

function domainOptions(value) {
  let autoCompleteOptions = domains.map((li) => value + li);
  if (value?.length >= 88) {
    const tempOptions = [];
    domains.forEach((li) => {
      if ((value + li).length <= 100) {
        tempOptions.push(value + li);
      }
    });
    autoCompleteOptions = tempOptions;
  }
  return autoCompleteOptions;
}

function yearofExperience() {
  const list = [];
  Array.from(Array(20)).forEach((_, index) => {
    list.push({ value: index + 1, label: index === 19 ? '20+' : index + 1 });
  });
  return list;
}

const hasTextInside = (htmlString) => {
  const strippedText = htmlString.replace(/<[^>]*>/g, '').trim();
  return strippedText.length > 0;
};

const isDateExceeding60Days = (createdAt) => {
  const createdAtDate = moment(createdAt);
  const currentDate = moment();
  return currentDate.diff(createdAtDate, 'days') > 60;
};

function getLineCountFromHtml(htmlContent, options = {}) {
  const { width = 600, fontSize = 16, lineHeight = 1.5 } = options;

  const tempDiv = document.createElement('div');

  Object.assign(tempDiv.style, {
    position: 'absolute',
    visibility: 'hidden',
    zIndex: '-1',
    width: `${width}px`,
    fontSize: `${fontSize}px`,
    lineHeight: lineHeight,
    whiteSpace: 'normal',
    padding: '0',
    margin: '0',
    border: '0',
  });

  tempDiv.innerHTML = `
    <style>
      * {
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box;
      }
      p, li, ul, ol, strong, em, span, a {
        margin: 0 !important;
        padding: 0 !important;
        font-size: ${fontSize}px !important;
        line-height: ${lineHeight} !important;
      }
    </style>
    <div>${htmlContent}</div>
  `;

  document.body.appendChild(tempDiv);

  const totalHeight = tempDiv.offsetHeight;
  const lineHeightPx = fontSize * lineHeight;
  const lineCount = Math.round(totalHeight / lineHeightPx);

  document.body.removeChild(tempDiv);

  return lineCount;
}

function stripHtmlTags(html) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
}

const highlightHTML = (htmlString, keyword) => {
  if (!keyword) return htmlString;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const regex = new RegExp(`(${keyword})`, 'gi');

  const walk = (node) => {
    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        if (regex.test(child.nodeValue)) {
          const span = document.createElement('span');
          span.innerHTML = child.nodeValue.replace(
            regex,
            `<span class='search-highlight'>$1</span>`
          );
          child.replaceWith(...span.childNodes);
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        walk(child);
      }
    });
  };

  walk(doc.body);

  return doc.body.innerHTML;
};

const handleGetMention = (htmlString) => {
  const container = document.createElement('div');
  container.innerHTML = htmlString;

  const matches = [...container.querySelectorAll('strong')].filter((el) => {
    return (
      el.style.color === 'rgb(25, 118, 210)' && el.style.fontSize === '14px'
    );
  });

  return matches.map((el) => el.textContent);
};

const formatDateTime = (date) => {
  const timeAgo = moment(date || moment()).fromNow(true)
  const [count, unit] = timeAgo?.split(' ');
  return count + ' ' + (timeMapping[unit] || unit);
}

const getFileName = (url) => {
  const fullName = url.split('/').pop();
  const nameWithExt = fullName.substring(fullName.indexOf('-') + 1);
  const nameOnly = nameWithExt.substring(0, nameWithExt.lastIndexOf('.'));
  return nameOnly;
};

const getFileType = (url) => {
  const filename = url.split('/').pop();
  const extension = filename.split('.').pop();
  return extension.toLowerCase();
};

const handleOpenLinkInBrower = async (url) => {
  const fullUrl =
    url.startsWith('http://') || url.startsWith('https://')
      ? url
      : `https://${url}`;
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url: fullUrl });
  } else {
    window.open(fullUrl, '_blank');
  }
};

export {
  domainOptions,
  yearofExperience,
  usernameRegex,
  UrlRegex,
  EmailRegex,
  swipeModalWidth,
  hasTextInside,
  isDateExceeding60Days,
  getLineCountFromHtml,
  stripHtmlTags,
  highlightHTML,
  handleGetMention,
  formatDateTime,
  getFileName,
  getFileType,
  handleOpenLinkInBrower
};
